/**
 * Storage Utility
 * localStorage 的封裝工具，提供統一的本地儲存介面
 * 替代 @jetthai/cuora 的 storage 模組
 * 支援過期時間設定
 * SSR 相容：在伺服器端自動降級為 no-op
 */

// SSR 檢查：確保 localStorage 可用
const isClient = typeof window !== 'undefined' && typeof localStorage !== 'undefined'

const storage = {
  get(name, options) {
    // SSR 環境直接返回 null
    if (!isClient) {
      return null
    }

    let itemStr = null
    try {
      itemStr = localStorage.getItem(name)
    } catch (error) {
      console.error(`Error getting item from localStorage: ${error}`)
      return null
    }

    if (!itemStr) {
      return null
    }

    try {
      const item = JSON.parse(itemStr)
      if (item.expiry && new Date().getTime() > item.expiry) {
        localStorage.removeItem(name)
        return null
      }
      return 'value' in item ? item.value : item
    } catch (error) {
      console.error(`Error parsing item from localStorage: ${error}`)
      return null
    }
  },

  set(name, value, options) {
    // SSR 環境直接返回
    if (!isClient) {
      return
    }

    const item = { value }

    if (options?.maxAge) {
      item.expiry = new Date().getTime() + options.maxAge * 1000
    }
    try {
      localStorage.setItem(name, JSON.stringify(item))
    } catch (error) {
      console.error(`Error setting item in localStorage: ${error}`)
    }
  },

  remove(name, options) {
    // SSR 環境直接返回
    if (!isClient) {
      return
    }

    try {
      localStorage.removeItem(name)
    } catch (error) {
      console.error(`Error removing item from localStorage: ${error}`)
    }
  },

  clear() {
    // SSR 環境直接返回
    if (!isClient) {
      return
    }

    try {
      localStorage.clear()
    } catch (error) {
      console.error(`Error clearing localStorage: ${error}`)
    }
  }
}

export default storage
export { storage }
